/*
 *
 * Copyright (c) 1999-2021 Luciad All Rights Reserved.
 *
 * Luciad grants you ("Licensee") a non-exclusive, royalty free, license to use,
 * modify and redistribute this software in source and binary code form,
 * provided that i) this copyright notice and license appear on all copies of
 * the software; and ii) Licensee does not utilize the software in a manner
 * which is disparaging to Luciad.
 *
 * This software is provided "AS IS," without a warranty of any kind. ALL
 * EXPRESS OR IMPLIED CONDITIONS, REPRESENTATIONS AND WARRANTIES, INCLUDING ANY
 * IMPLIED WARRANTY OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE OR
 * NON-INFRINGEMENT, ARE HEREBY EXCLUDED. LUCIAD AND ITS LICENSORS SHALL NOT BE
 * LIABLE FOR ANY DAMAGES SUFFERED BY LICENSEE AS A RESULT OF USING, MODIFYING
 * OR DISTRIBUTING THE SOFTWARE OR ITS DERIVATIVES. IN NO EVENT WILL LUCIAD OR ITS
 * LICENSORS BE LIABLE FOR ANY LOST REVENUE, PROFIT OR DATA, OR FOR DIRECT,
 * INDIRECT, SPECIAL, CONSEQUENTIAL, INCIDENTAL OR PUNITIVE DAMAGES, HOWEVER
 * CAUSED AND REGARDLESS OF THE THEORY OF LIABILITY, ARISING OUT OF THE USE OF
 * OR INABILITY TO USE SOFTWARE, EVEN IF LUCIAD HAS BEEN ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGES.
 */
function getValue(nodeRange, precision, displayScale, unit) {
  var displayValue;
  var displayInfo;
  if (displayScale) {
    for (var i = 0; i < displayScale.length; i++) {
      if (nodeRange <= displayScale[i].max) {
        displayInfo = displayScale[i];
        break;
      }
    }
    displayValue = displayInfo ? displayInfo.text : nodeRange;
  } else {
    displayValue = nodeRange.toFixed(precision);
  }
  if (unit) {
    displayValue += " " + unit;
  }
  return displayValue;
}

function createSlider(min, max, step, className) {
  var slider = document.createElement('input');
  slider.className = "filter form-control slider-control " + className;
  slider.setAttribute("type", "range");
  slider.setAttribute("min", min);
  slider.setAttribute("max", max);
  slider.setAttribute("title", "range: " + min + "-" + max);
  slider.setAttribute("step", step);
  return slider;
}

function createNodeValue(className) {
  var nodeValue = document.createElement('div');
  nodeValue.className = "slider-value " + className;
  return nodeValue;
}

function createContainer(nodes, nodeLabel, id, className) {
  var nodeValueLeft = nodes.nodeValueLeft;
  var nodeRange1 = nodes.nodeRange1;
  var nodeRange2 = nodes.nodeRange2;
  var nodeValueRight = nodes.nodeValueRight;
  var nodeContainer = document.createElement("span");
  nodeContainer.className = "slider";
  nodeContainer.appendChild(nodeLabel);
  if (id) {
    nodeContainer.id = id;
  }
  if (className) {
    nodeContainer.className += " " + className;
  }
  nodeContainer.appendChild(nodeValueLeft);
  nodeContainer.appendChild(nodeRange1);
  nodeContainer.appendChild(nodeRange2);
  nodeContainer.appendChild(nodeValueRight);
  return nodeContainer;
}

/**
 * @class
 * @constructor
 * @param {Object} parent The container node to hold the slider component.
 * @param {Object} options The configuration object to control look and behavior of the slider.
 * @param {String} [options.label = ""] The label text
 * @param {param} options.min The minimum value of the slider range
 * @param {param} options.max The maximum value of the slider range
 * @param {param} options.value The initial slider value
 * @param {param} [options.step = 1] The slider step
 * @param {String} [options.id = ""] The id used for slider's container
 * @param {String | Array} [options.classNames = ""] The CSS classes used for slider's container. Can be string or array
 * @param {String} [options.unit = ""] The unit text to display
 * @param {Number} [options.precision = 1] The displayed value decimal precision
 * @param {Array} [options.displayScale] The array of objects that determine the displayed text based on thresholds
 *                                       Each definition object contains 2 properties: min, text.
 * @param {Object} [options.tooltip = ""] The UI tooltip.
 * @param {function} [options.valueFormatter] The custom formatter function.
 * @param {boolean} [options.disabled = false] States if the slider should be initially disabled.
 */
function SliderComponent(parent, options) {
  options = options || {};
  var value = options.value;
  var label = options.label || "";
  var min = options.min || 0;
  var max = options.max || 100;
  var step = options.step || 1;
  var id = options.id;
  var className = !options.classNames ? "" : Array.isArray(options.classNames) ? options.classNames.join(" ") : options.classNames;
  var unit = options.unit || "";
  var precision = options.precision || 1;
  var displayScale = options.displayScale;
  var toolTip = options.tooltip;
  if (options.valueFormatter && typeof options.valueFormatter === "function") {
    this.valueFormatter = options.valueFormatter;
  }

  var nodeLabel = document.createElement('label');
  nodeLabel.appendChild(document.createTextNode(label));
  if (toolTip) {
    nodeLabel.setAttribute("title", toolTip);
  }

  this.nodeRange1 = createSlider(min, max, step, "slider-one");
  this.nodeValueLeft = createNodeValue("slider-value-left");
  this.nodeRange2 = createSlider(min, max, step, "slider-two");
  this.nodeValueRight = createNodeValue("slider-value-right");
  this.container = createContainer({
    nodeValueLeft: this.nodeValueLeft,
    nodeRange1: this.nodeRange1,
    nodeRange2: this.nodeRange2,
    nodeValueRight: this.nodeValueRight
  }, nodeLabel, id, className);
  parent.appendChild(this.container);

  this.fallback = !!window.StyleMedia; // Disable dual sliders for IE & Edge
  this.displayScale = displayScale;
  this.disabled = options.disabled;
  this.precision = precision;
  this.unit = unit;
  this.value = value;

  // ensure displaying slider's current value whenever changed
  this.addHandler = this.addHandler.bind(this);
  this.addHandler(this.updateDisplay.bind(this));

  if (options.onInit) {
    options.onInit();
  }
}

SliderComponent.prototype.formatDisplay = function(numValue) {
  var value = getValue(numValue, this.precision, this.displayScale, this.unit);
  return this.valueFormatter ? this.valueFormatter(value) : value;
};

SliderComponent.prototype.updateDisplay = function() {
  var range1AsNum = this.nodeRange1.valueAsNumber;
  var range2AsNum = this.nodeRange2.valueAsNumber;
  var range1 = this.formatDisplay(range1AsNum);
  var range2 = this.formatDisplay(range2AsNum);
  var low;
  var high;
  if (range1AsNum < range2AsNum) {
    this.nodeValueLeft.innerText = range1;
    this.nodeValueRight.innerText = range2;
    low = range1AsNum;
    high = range2AsNum;
  } else {
    this.nodeValueLeft.innerText = range2;
    this.nodeValueRight.innerText = range1;
    low = range2AsNum;
    high = range1AsNum;
  }
  var min = Number(this.nodeRange2.getAttribute("min"));
  var max = Number(this.nodeRange2.getAttribute("max"));
  this.nodeRange1.style.setProperty("--low", 100 * ((low - min) / (max - min)) + 1 + "%");
  this.nodeRange1.style.setProperty("--high", 100 * ((high - min) / (max - min)) - 1 + "%");
};

SliderComponent.prototype.addHandler = function(handler) {
  this.dual && this.nodeRange1.addEventListener("input", handler, false);
  this.nodeRange2.addEventListener("input", handler, false);
  this.dual && this.nodeRange1.addEventListener("change", handler, false);
  this.nodeRange2.addEventListener("change", handler, false);
  /* Immediately run the handler once for each slider to synch it with whichever this slider is supposed to modify */
  this.dual && handler({
    target: this.nodeRange1
  });
  handler({
    target: this.nodeRange2
  });
};

Object.defineProperty(SliderComponent.prototype, "value", {
  configurable: false,
  enumerable: true,
  get: function() {
    if (!this.dual) {
      return this.nodeRange2.valueAsNumber;
    }
    var range1 = this.nodeRange1.valueAsNumber;
    var range2 = this.nodeRange2.valueAsNumber;
    if (range1 < range2) {
      return [range1, range2];
    } else {
      return [range2, range1];
    }
  },
  set: function(newValue) {
    var value;
    this.dual = false;
    if (!newValue) {
      value = [this.min, this.max];
    } else if (!Array.isArray(newValue)) {
      value = [this.min, newValue];
    } else {
      value = newValue;
      this.dual = true;
    }
    this.nodeRange1.value = value[0];
    this.nodeRange2.value = value[1];
    if (this.dual && !this.fallback) {
      this.container.classList.add("dual-slider");
    } else {
      this.container.classList.remove("dual-slider");
    }
  }
});

Object.defineProperty(SliderComponent.prototype, "disabled", {
  configurable: false,
  enumerable: true,
  get: function() {
    return this.nodeRange1.disabled && this.nodeRange2.disabled;
  },
  set: function(state) {
    this.nodeRange1.disabled = state;
    this.nodeRange2.disabled = state;
  }
});

Object.defineProperty(SliderComponent.prototype, "min", {
  configurable: false,
  enumerable: true,
  get: function() {
    return this.nodeRange1.getAttribute("min");
  },
  set: function( /*state*/ ) {
    throw Error("The min property is not mutable");
  }
});

Object.defineProperty(SliderComponent.prototype, "max", {
  configurable: false,
  enumerable: true,
  get: function() {
    return this.nodeRange1.getAttribute("max");
  },
  set: function( /*state*/ ) {
    throw Error("The max property is not mutable");
  }
});

export {SliderComponent};